export default __webpack_public_path__ + "static/media/Milk2Icecream_03.ac860799.png";